import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import CardTemplate from 'templates/CardTemplate'

const StyledComponent = styled(({css, ...rest}) => <CardTemplate {...rest} />)`
  background: rgba(255,0,0,0.08);
  padding: ${p => p.theme.m};
  margin-bottom: ${p => p.theme.m};
  overflow: auto;
  ${p => p.css}
`

const _ErrorWrapper = (props) => <StyledComponent {...props} />
_ErrorWrapper.propTypes = {
  css: PropTypes.string,
}

export default _ErrorWrapper

